import { VuexResponse } from '@/helpers/vuex-action-builder'
import BookingViewModel from '@/models/bookings/bookingViewModel'
import PendingBookingSummaryViewModel from '@/models/bookings/pendingBookingSummaryViewModel'
import LoadingKeys from '@/shared/constants/core/LoadingKeys'
import sleep from '@/utils/sleep'

const getDefaultState = () => {
  return {
    flyout: {
      booking: {},
      show: false,
      error: false,
    },
  }
}

const state = getDefaultState()

export default {
  namespaced: true,
  state,
  getters: {
    moduleName: () => 'booking-approvals',
    isLoadingApprovalsList: (state, getters, rootState, rootGetters) =>
      rootGetters.isLoadingByKey(
        LoadingKeys.bookingApprovals.loadingApprovalCount
      ),
    isLoadingFlyout: (state, getters, rootState, rootGetters) =>
      rootGetters.isLoadingByKey(
        LoadingKeys.bookingApprovals.loadingApprovalDetails
      ),
    isLoadingSubmitPendingApproval: (state, getters, rootState, rootGetters) =>
      rootGetters.isLoadingByKey(
        LoadingKeys.bookingApprovals.loadingSubmitPendingApproval
      ),
    activeBooking: (state) => state.flyout.booking,
    showFlyout: (state) => state.flyout.show,
    flyoutHasError: (state) => state.flyout.error,
    showDetailsContent: (state) => !!state.flyout.booking?.id,
  },
  mutations: {
    SET_FLYOUT(state, { key, value }) {
      state.flyout[key] = value
    },
    RESET_FLYOUT(state) {
      state.flyout = {
        booking: {},
        show: false,
        error: false,
      }
    },
    SET_STATE(state, { key, value }) {
      state[key] = value
    },
    CLEAR_STORE(state) {
      // Resets store to default state
      Object.assign(state, getDefaultState())
    },
  },
  actions: {
    async mockSubmitPendingApproval() {
      await sleep(1500)
      return {
        status: 204,
        data: {},
      }
    },
    async loadPendingApprovals({ commit }) {
      return await new VuexResponse(commit)
        .request(() => this.$api.pendingBookings.get())
        .withLoadingByKey(LoadingKeys.bookingApprovals.loadingApprovalCount)
        .transform((data) =>
          data.map((item) => new PendingBookingSummaryViewModel(item))
        )
        .go()
    },
    async loadApprovalDetails({ commit }, bookingId) {
      return await new VuexResponse(commit)
        .request(() => this.$api.bookings.get(bookingId))
        .withLoadingByKey(LoadingKeys.bookingApprovals.loadingApprovalDetails)
        .transform((data) => new BookingViewModel(data))
        .go()
    },
    async submitPendingApproval({ commit, dispatch }, payload) {
      return await new VuexResponse(commit)
        .request(() => this.$api.pendingBookings.action(payload))
        .withLoadingByKey(
          LoadingKeys.bookingApprovals.loadingSubmitPendingApproval
        )
        .withSuccessToast(
          payload.action === 'accept'
            ? this.$i18n.t('booking.details.approvals.submit.acceptToast', {
                companyNameShort: this.$i18n.t('app.companyNameShort'),
              })
            : this.$i18n.t('booking.details.approvals.submit.rejectToast')
        )
        .withFailureToast(
          this.$i18n.t('booking.details.approvals.submit.failureToast')
        )
        .go()
    },
    openFlyout({ commit }) {
      commit('SET_FLYOUT', { key: 'show', value: true })
    },
    setFlyout({ commit }, data) {
      commit('SET_FLYOUT', data)
    },
    resetFlyout({ commit }) {
      return commit('RESET_FLYOUT')
    },
    /**
     * Resets store to default state.
     */
    clear({ commit }) {
      commit('CLEAR_STORE')
    },
  },
}
